module.exports = {"title":"Delete ticket","description":"Are you sure you want to delete that ticket?","yes":"Yes","no":"No"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/AlertModalStar/locales/fr.json
// module id = 1061
// module chunks = 0